<template>
    <div class="client-details">
      <div class="tabs1">
        <v-checkbox
          label="Client Details"
          v-model="clientDetails"
          :true-value="1"
          :false-value="0"
          @click="selectMainTab(`clientDetails`)"/>
        <v-checkbox
          label="Warehouse Details"
          v-model="warehouseDetails"
          :true-value="1"
          :false-value="0"
          @click="selectMainTab(`warehouseDetails`)"/>
        <v-checkbox
          label="Exception Sheets"
          v-model="exceptionDetails"
          :true-value="1"
          :false-value="0"
          @click="selectMainTab(`exceptionDetails`)"/>
        <v-checkbox
          label="Alert"
          v-model="alertDetails"
          :true-value="1"
          :false-value="0"
          @click="selectMainTab(`alertDetails`)"/>
      </div>
      <div class="tabs" v-if="tabs.length > 0">
        <button
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ active: activeTab === index }"
          @click="activeTab = index"
        >
          {{ tab.name }}
        </button>
      </div>
      <div class="content" v-if="tabs.length > 0">
        <component :is="tabs[activeTab].component" />
      </div>
    </div>
  </template>
  
  <script>
  import WarehouseDetails from "../ClientDetails/WarehouseDetails.vue";
  import CreateClientDetails from "../CreateException/CreateClientDetails.vue";
  import ProductDetails from "../ClientDetails/ProductDetails/ProductDetails.vue";       
  import ShippingDetails from '../ClientDetails/ShippingDetails.vue';
  import CustomerDetails from '../ClientDetails/CustomerDetails.vue'
  import ExternalParties from '../ClientDetails/ExternalParties.vue'
  
  export default {
    components: {
    CreateClientDetails,
      WarehouseDetails,
      ProductDetails,
      ShippingDetails,
      CustomerDetails,
      ExternalParties
    },
    data() {
      return {
        clientDetails:0,
        warehouseDetails:0,
        exceptionDetails:0,
        alertDetails:0,
        activeMainTab: 0,     
        activeTab: 0,  
        selectedTab: null,    
        tabs: [],             
      };
    },
    methods: {
      selectMainTab(mainTab) {
  
        if (mainTab === "clientDetails") {
          this.clientDetails = 1
          this.warehouseDetails = 0
          this.exceptionDetails = 0
          this.alertDetails = 0
          this.tabs = [
            { name: "CreateClientDetails", component: "CreateClientDetails" },
            // { name: "External Parties", component: "ExternalParties" },
            // { name: "Product Details", component: "ProductDetails" },
            // { name: "Customer Details", component: "CustomerDetails" },
          ];
        } else if (mainTab === "warehouseDetails") {
          this.clientDetails = 0
          this.warehouseDetails = 1
          this.exceptionDetails = 0
          this.alertDetails = 0
          this.tabs = [
            { name: "Warehouse POC", component: "WarehouseDetails" }, 
            { name: "Shipping Details", component: "ShippingDetails" },
          ];
        } else if (mainTab === "exceptionDetails"){
          this.clientDetails = 0
          this.warehouseDetails = 0
          this.exceptionDetails = 1
          this.alertDetails = 0
          this.tabs = []; 
        }
        else{
          this.clientDetails = 0
          this.warehouseDetails = 0
          this.exceptionDetails = 0
          this.alertDetails = 1
          this.tabs = [];         
        }
      }
    },
    mounted() {
      this.selectMainTab("clientDetails"); 
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .client-details {
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 100%;
  }
  .tabs1{
    display: flex;
    gap: 100px;
    margin-bottom:-28px;
  }
  
  .tabs {
    display: flex;
    gap: 30px;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  
    button {
      border: none;
      cursor: pointer;
      transition: 0.1s;
      font-size: 0.875rem;
  
      &.active {
        font-weight: 700;
        border-radius: 8px;
        padding: 5px 10px;
        background: #dd0e1a;
        color: #ffffff;
      }
    }
  
    @media (max-width: 768px) {
      flex-wrap: wrap;
    }
  
    @media (max-width: 480px) {
      flex-wrap: wrap;
    }
  }
  
  .content {
    width: 100%;
  }
  </style>
  